import type { FaireProductEntity } from "../../entity_types/product";

export const p_6y7bjteo0h: FaireProductEntity = {
  token: "p_6y7bjteo0h",
  type: "product",
  name: "Custom Tea Towel (Your Logo / Your Own Design)",
  brandToken: "b_191br80oqs",
  brandName: "The Cotton & Canvas Co.",
  imageUrl: "https://cdn.faire.com/fastly/ac957a0e164b7f7059220fbd2337adbaed67702b93b32abacce81a0419e0c62b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b6734558ec0c7573a759fc8311551af792ff20c7b6b7ba04338c43f7dd5fb668.jpeg",
    "https://cdn.faire.com/fastly/28a523884ede53ba33ba4edea671e122a5c2aef7f05e780cef10e547e04c47ca.jpeg",
    "https://cdn.faire.com/fastly/8ab5349c57dff77541ca6f8de2d776c9e50ee45ffa902bba6268ff1e19fadff5.jpeg"
  ],
  priceDollars: 7.5,
  description: "Customize this item with your artwork, logo or design!\n\nSimply submit your artwork and we'll print it for you! We kindly request the artwork to be in high resolution format. A PDF, EPS, PSD, or AI file is required to ensure the print is sharp and not pixelated. JPGs above 1000 pixels can be accepted.\nThese custom tea towels make the perfect gifts for the holidays, corporate events, client thank yous, birthdays, weddings and many more!\n\nTo purchase, kindly place your order and message us your artwork.\n\nA proof available upon request.\n\n• 100% Pure Ring Spun Cotton\n• Measures 28\" W x 28\" H\n• Designed, printed and manufactured in the USA\n\nAll personalized item sales are final. Personalized items are non-refundable.",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:42.337Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
